import { Inject, Injectable } from '@angular/core';
import { APP_ABILITY, AppAbility } from 'app/utils/ability.factory';

import { Action, Subject } from 'models/roles.model';
@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor(@Inject(APP_ABILITY) private ability: AppAbility,) { }

  canCreateArticles(): boolean {
    return this.ability.can(Action.Create, Subject.Articles);
  }

  canEditUser(targetAccount: any): boolean {
    return this.ability.can(Action.Update, {
      id: targetAccount.id,
      role: targetAccount.accountRoles.organizationRole
    });
  }

  cannotCreateArticles(): boolean {
    return this.ability.cannot(Action.Create, Subject.Articles);
  }

  canReadArticles(): boolean {
    return this.ability.can(Action.Read, Subject.Articles);
  }

  cannotReadArticles(): boolean {
    return this.ability.cannot(Action.Read, Subject.Articles);
  }

  canUpdateArticles(): boolean {
    return this.ability.can(Action.Update, Subject.Articles);
  }

  cannotUpdateArticles(): boolean {
    return this.ability.cannot(Action.Update, Subject.Articles);
  }

  canDeleteArticles(): boolean {
    return this.ability.can(Action.Delete, Subject.Articles);
  }

  cannotDeleteArticles(): boolean {
    return this.ability.cannot(Action.Delete, Subject.Articles);
  }

  canManageArticles(): boolean {
    return this.ability.can(Action.Manage, Subject.Articles);
  }

  cannotManageArticles(): boolean {
    return this.ability.cannot(Action.Manage, Subject.Articles);
  }

  canCreateBranch(): boolean {
    return this.ability.can(Action.Create, Subject.Branch);
  }

  cannotCreateBranch(): boolean {
    return this.ability.cannot(Action.Create, Subject.Branch);
  }

  canReadBranch(): boolean {
    return this.ability.can(Action.Read, Subject.Branch);
  }

  cannotReadBranch(): boolean {
    return this.ability.cannot(Action.Read, Subject.Branch);
  }

  canUpdateBranch(): boolean {
    return this.ability.can(Action.Update, Subject.Branch);
  }

  cannotUpdateBranch(): boolean {
    return this.ability.cannot(Action.Update, Subject.Branch);
  }

  canDeleteBranch(): boolean {
    return this.ability.can(Action.Delete, Subject.Branch);
  }

  cannotDeleteBranch(): boolean {
    return this.ability.cannot(Action.Delete, Subject.Branch);
  }

  canManageBranch(): boolean {
    return this.ability.can(Action.Manage, Subject.Branch);
  }

  cannotManageBranch(): boolean {
    return this.ability.cannot(Action.Manage, Subject.Branch);
  }

  canCreateConditions(): boolean {
    return this.ability.can(Action.Create, Subject.Conditions);
  }

  cannotCreateConditions(): boolean {
    return this.ability.cannot(Action.Create, Subject.Conditions);
  }

  canReadConditions(): boolean {
    return this.ability.can(Action.Read, Subject.Conditions);
  }

  cannotReadConditions(): boolean {
    return this.ability.cannot(Action.Read, Subject.Conditions);
  }

  canUpdateConditions(): boolean {
    return this.ability.can(Action.Update, Subject.Conditions);
  }

  cannotUpdateConditions(): boolean {
    return this.ability.cannot(Action.Update, Subject.Conditions);
  }

  canDeleteConditions(): boolean {
    return this.ability.can(Action.Delete, Subject.Conditions);
  }

  cannotDeleteConditions(): boolean {
    return this.ability.cannot(Action.Delete, Subject.Conditions);
  }

  canManageConditions(): boolean {
    return this.ability.can(Action.Manage, Subject.Conditions);
  }

  cannotManageConditions(): boolean {
    return this.ability.cannot(Action.Manage, Subject.Conditions);
  }

  canCreateCustomer(): boolean {
    return this.ability.can(Action.Create, Subject.Customer);
  }

  cannotCreateCustomer(): boolean {
    return this.ability.cannot(Action.Create, Subject.Customer);
  }

  canReadCustomer(): boolean {
    return this.ability.can(Action.Read, Subject.Customer);
  }

  cannotReadCustomer(): boolean {
    return this.ability.cannot(Action.Read, Subject.Customer);
  }

  canUpdateCustomer(): boolean {
    return this.ability.can(Action.Update, Subject.Customer);
  }

  cannotUpdateCustomer(): boolean {
    return this.ability.cannot(Action.Update, Subject.Customer);
  }

  canDeleteCustomer(): boolean {
    return this.ability.can(Action.Delete, Subject.Customer);
  }

  cannotDeleteCustomer(): boolean {
    return this.ability.cannot(Action.Delete, Subject.Customer);
  }

  canManageCustomer(): boolean {
    return this.ability.can(Action.Manage, Subject.Customer);
  }

  cannotManageCustomer(): boolean {
    return this.ability.cannot(Action.Manage, Subject.Customer);
  }

  canCreateTemplates(): boolean {
    return this.ability.can(Action.Create, Subject.Templates);
  }

  cannotCreateTemplates(): boolean {
    return this.ability.cannot(Action.Create, Subject.Templates);
  }

  canReadTemplates(): boolean {
    return this.ability.can(Action.Read, Subject.Templates);
  }

  cannotReadTemplates(): boolean {
    return this.ability.cannot(Action.Read, Subject.Templates);
  }

  canUpdateTemplates(): boolean {
    return this.ability.can(Action.Update, Subject.Templates);
  }

  cannotUpdateTemplates(): boolean {
    return this.ability.cannot(Action.Update, Subject.Templates);
  }

  canDeleteTemplates(): boolean {
    return this.ability.can(Action.Delete, Subject.Templates);
  }

  cannotDeleteTemplates(): boolean {
    return this.ability.cannot(Action.Delete, Subject.Templates);
  }

  canManageTemplates(): boolean {
    return this.ability.can(Action.Manage, Subject.Templates);
  }

  cannotManageTemplates(): boolean {
    return this.ability.cannot(Action.Manage, Subject.Templates);
  }

  canCreateObjekt(): boolean {
    return this.ability.can(Action.Create, Subject.Objekt);
  }

  cannotCreateObjekt(): boolean {
    return this.ability.cannot(Action.Create, Subject.Objekt);
  }

  canReadObjekt(): boolean {
    return this.ability.can(Action.Read, Subject.Objekt);
  }

  cannotReadObjekt(): boolean {
    return this.ability.cannot(Action.Read, Subject.Objekt);
  }

  canUpdateObjekt(): boolean {
    return this.ability.can(Action.Update, Subject.Objekt);
  }

  cannotUpdateObjekt(): boolean {
    return this.ability.cannot(Action.Update, Subject.Objekt);
  }

  canDeleteObjekt(): boolean {
    return this.ability.can(Action.Delete, Subject.Objekt);
  }

  cannotDeleteObjekt(): boolean {
    return this.ability.cannot(Action.Delete, Subject.Objekt);
  }

  canManageObjekt(): boolean {
    return this.ability.can(Action.Manage, Subject.Objekt);
  }

  cannotManageObjekt(): boolean {
    return this.ability.cannot(Action.Manage, Subject.Objekt);
  }

  canCreateOfferTemplates(): boolean {
    return this.ability.can(Action.Create, Subject.OfferTemplates);
  }

  cannotCreateOfferTemplates(): boolean {
    return this.ability.cannot(Action.Create, Subject.OfferTemplates);
  }

  canReadOfferTemplates(): boolean {
    return this.ability.can(Action.Read, Subject.OfferTemplates);
  }

  cannotReadOfferTemplates(): boolean {
    return this.ability.cannot(Action.Read, Subject.OfferTemplates);
  }

  canUpdateOfferTemplates(): boolean {
    return this.ability.can(Action.Update, Subject.OfferTemplates);
  }

  cannotUpdateOfferTemplates(): boolean {
    return this.ability.cannot(Action.Update, Subject.OfferTemplates);
  }

  canDeleteOfferTemplates(): boolean {
    return this.ability.can(Action.Delete, Subject.OfferTemplates);
  }

  cannotDeleteOfferTemplates(): boolean {
    return this.ability.cannot(Action.Delete, Subject.OfferTemplates);
  }

  canManageOfferTemplates(): boolean {
    return this.ability.can(Action.Manage, Subject.OfferTemplates);
  }

  cannotManageOfferTemplates(): boolean {
    return this.ability.cannot(Action.Manage, Subject.OfferTemplates);
  }

  canCreateOfferTemplateSettings(): boolean {
    return this.ability.can(Action.Create, Subject.OfferTemplateSettings);
  }

  cannotCreateOfferTemplateSettings(): boolean {
    return this.ability.cannot(Action.Create, Subject.OfferTemplateSettings);
  }

  canReadOfferTemplateSettings(): boolean {
    return this.ability.can(Action.Read, Subject.OfferTemplateSettings);
  }

  cannotReadOfferTemplateSettings(): boolean {
    return this.ability.cannot(Action.Read, Subject.OfferTemplateSettings);
  }

  canUpdateOfferTemplateSettings(): boolean {
    return this.ability.can(Action.Update, Subject.OfferTemplateSettings);
  }

  cannotUpdateOfferTemplateSettings(): boolean {
    return this.ability.cannot(Action.Update, Subject.OfferTemplateSettings);
  }

  canDeleteOfferTemplateSettings(): boolean {
    return this.ability.can(Action.Delete, Subject.OfferTemplateSettings);
  }

  cannotDeleteOfferTemplateSettings(): boolean {
    return this.ability.cannot(Action.Delete, Subject.OfferTemplateSettings);
  }

  canManageOfferTemplateSettings(): boolean {
    return this.ability.can(Action.Manage, Subject.OfferTemplateSettings);
  }

  cannotManageOfferTemplateSettings(): boolean {
    return this.ability.cannot(Action.Manage, Subject.OfferTemplateSettings);
  }

  canCreateOfferSettings(): boolean {
    return this.ability.can(Action.Create, Subject.OfferSettings);
  }

  cannotCreateOfferSettings(): boolean {
    return this.ability.cannot(Action.Create, Subject.OfferSettings);
  }

  canReadOfferSettings(): boolean {
    return this.ability.can(Action.Read, Subject.OfferSettings);
  }

  cannotReadOfferSettings(): boolean {
    return this.ability.cannot(Action.Read, Subject.OfferSettings);
  }

  canUpdateOfferSettings(): boolean {
    return this.ability.can(Action.Update, Subject.OfferSettings);
  }

  cannotUpdateOfferSettings(): boolean {
    return this.ability.cannot(Action.Update, Subject.OfferSettings);
  }

  canDeleteOfferSettings(): boolean {
    return this.ability.can(Action.Delete, Subject.OfferSettings);
  }

  cannotDeleteOfferSettings(): boolean {
    return this.ability.cannot(Action.Delete, Subject.OfferSettings);
  }

  canManageOfferSettings(): boolean {
    return this.ability.can(Action.Manage, Subject.OfferSettings);
  }

  cannotManageOfferSettings(): boolean {
    return this.ability.cannot(Action.Manage, Subject.OfferSettings);
  }

  canCreateBranches(): boolean {
    return this.ability.can(Action.Create, Subject.Branches);
  }

  cannotCreateBranches(): boolean {
    return this.ability.cannot(Action.Create, Subject.Branches);
  }

  canReadBranches(): boolean {
    return this.ability.can(Action.Read, Subject.Branches);
  }

  cannotReadBranches(): boolean {
    return this.ability.cannot(Action.Read, Subject.Branches);
  }

  canUpdateBranches(): boolean {
    return this.ability.can(Action.Update, Subject.Branches);
  }

  cannotUpdateBranches(): boolean {
    return this.ability.cannot(Action.Update, Subject.Branches);
  }

  canDeleteBranches(): boolean {
    return this.ability.can(Action.Delete, Subject.Branches);
  }

  cannotDeleteBranches(): boolean {
    return this.ability.cannot(Action.Delete, Subject.Branches);
  }

  canManageBranches(): boolean {
    return this.ability.can(Action.Manage, Subject.Branches);
  }

  cannotManageBranches(): boolean {
    return this.ability.cannot(Action.Manage, Subject.Branches);
  }

  canCreateAccount(): boolean {
    return this.ability.can(Action.Create, Subject.Account);
  }

  cannotCreateAccount(): boolean {
    return this.ability.cannot(Action.Create, Subject.Account);
  }

  canReadAccount(): boolean {
    return this.ability.can(Action.Read, Subject.Account);
  }

  cannotReadAccount(): boolean {
    return this.ability.cannot(Action.Read, Subject.Account);
  }

  canUpdateAccount(): boolean {
    return this.ability.can(Action.Update, Subject.Account);
  }

  cannotUpdateAccount(): boolean {
    return this.ability.cannot(Action.Update, Subject.Account);
  }

  canDeleteAccount(): boolean {
    return this.ability.can(Action.Delete, Subject.Account);
  }

  cannotDeleteAccount(): boolean {
    return this.ability.cannot(Action.Delete, Subject.Account);
  }

  canManageAccount(): boolean {
    return this.ability.can(Action.Manage, Subject.Account);
  }

  cannotManageAccount(): boolean {
    return this.ability.cannot(Action.Manage, Subject.Account);
  }

  canCreateContactPerson(): boolean {
    return this.ability.can(Action.Create, Subject.ContactPerson);
  }

  cannotCreateContactPerson(): boolean {
    return this.ability.cannot(Action.Create, Subject.ContactPerson);
  }

  canReadContactPerson(): boolean {
    return this.ability.can(Action.Read, Subject.ContactPerson);
  }

  cannotReadContactPerson(): boolean {
    return this.ability.cannot(Action.Read, Subject.ContactPerson);
  }

  canUpdateContactPerson(): boolean {
    return this.ability.can(Action.Update, Subject.ContactPerson);
  }

  cannotUpdateContactPerson(): boolean {
    return this.ability.cannot(Action.Update, Subject.ContactPerson);
  }

  canDeleteContactPerson(): boolean {
    return this.ability.can(Action.Delete, Subject.ContactPerson);
  }

  cannotDeleteContactPerson(): boolean {
    return this.ability.cannot(Action.Delete, Subject.ContactPerson);
  }

  canManageContactPerson(): boolean {
    return this.ability.can(Action.Manage, Subject.ContactPerson);
  }

  cannotManageContactPerson(): boolean {
    return this.ability.cannot(Action.Manage, Subject.ContactPerson);
  }

  canReadHeaderNavSettings(): boolean {
    return this.ability.can(Action.Read, Subject.HeaderNavSettings);
  }

  cannotReadHeaderNavSettings(): boolean {
    return this.ability.cannot(Action.Read, Subject.HeaderNavSettings);
  }

  canImportCustomer(): boolean {
    return this.ability.can(Action.Create, Subject.ImportCustomer);
  }

  canExportCustomer(): boolean {
    return this.ability.can(Action.Create, Subject.ImportCustomer);
  }

  canImportArticles(): boolean {
    return this.ability.can(Action.Create, Subject.ImportArticles);
  }

  canExportArticles(): boolean {
    return this.ability.can(Action.Create, Subject.ImportArticles);
  }
}
